export const companyLandings = {
    'azar-battery': {
        name: 'آذر باتری',
        englishName: 'AZAR BATTERY',
        description:
            'برای انتخاب باتری آذر، ظرفیت، ابعاد و شرایط گارانتی را کنار هم بررسی کن. اینجا راهنمای انتخاب و دسترسی به مشاوره خرید را پیدا می‌کنی.',
        guide: 'فقط نام شرکت برای انتخاب باتری کافی نیست. قبل از خرید، آمپر پیشنهادی سازنده خودرو، ابعاد محل نصب و جهت قطب‌ها را بررسی کن. اگر مدل موردنظرت را پیدا نکردی، از پشتیبانی برای بررسی گزینه‌های سازگار کمک بگیر.',
        brands: [] as { id: number; name: string }[]
    },
    'aco-battery': {
        name: 'آکو باتری',
        englishName: 'ACO BATTERY',
        description:
            'باتری‌های تینو برای ماشین و موتورسیکلت را یک‌جا ببین؛ ظرفیت، قیمت و گارانتی مدل‌ها را مقایسه کن و باتری مناسب وسیله‌ات را انتخاب کن.',
        guide: 'در کاتالوگ آکو، محصولات تینو برای خودرو و موتورسیکلت در دسترس‌اند. اول نوع وسیله را مشخص کن و بعد آمپر و مشخصات نصب را بررسی کن؛ باتری خودرو و موتورسیکلت را نمی‌توان فقط بر اساس نام برند با هم جایگزین کرد.',
        brands: [{ id: 4, name: 'تینو' }]
    },
    'borna-battery': {
        name: 'برنا باتری',
        englishName: 'BORNA BATTERY',
        description: 'مدل‌های ایاس را با قیمت روز و مشخصات نصب مقایسه کن. با انتخاب آمپر مناسب، سریع‌تر به گزینه‌های سازگار با ماشینت برس.',
        guide: 'محصولات ایاس در این صفحه کنار هم قرار گرفته‌اند تا ظرفیت و گارانتی مدل‌ها را راحت‌تر بررسی کنی. علاوه بر آمپر، جهت قطب و ارتفاع باتری را با مشخصات ماشینت تطبیق بده؛ قیمت به‌تنهایی معیار مناسبی برای انتخاب نیست.',
        brands: [{ id: 12, name: 'ایاس' }]
    },
    'sepahan-battery': {
        name: 'سپاهان باتری',
        englishName: 'SEPAHAN BATTERY',
        description: 'اوربیتال، سوزوکی و اتمیک را در یک کاتالوگ مقایسه کن؛ مدل‌ها را بر اساس آمپر و قیمت مرتب کن و جزئیات گارانتی هر محصول را ببین.',
        guide: 'برای مقایسه اوربیتال، سوزوکی و اتمیک، ابتدا آمپر یکسان را انتخاب کن. بعد سراغ قیمت، مدت گارانتی، ارتفاع و جهت قطب‌ها برو. نام‌های مشابه در خانواده اوربیتال هم ممکن است مشخصات متفاوتی داشته باشند؛ جزئیات هر مدل را جداگانه ببین.',
        brands: [
            { id: 3, name: 'اوربیتال پاورپلاس' },
            { id: 39, name: 'اوربیتال سیلور پلاس' },
            { id: 5, name: 'سوزوکی' },
            { id: 8, name: 'اتمیک' }
        ]
    },
    'saba-battery': {
        name: 'صبا باتری',
        englishName: 'SABA BATTERY',
        description:
            'واریان، واریان پلاس، اکسون و صبا باتری را یک‌جا ببین. قیمت، ظرفیت و شرایط گارانتی را بررسی کن و انتخابت را با مشخصات وسیله‌ات تطبیق بده.',
        guide: 'برای انتخاب از میان مدل‌های صبا، واریان، واریان پلاس و اکسون، فیلتر برند و آمپر را با هم استفاده کن. مدل‌های هم‌آمپر را با توجه به مشخصات نصب و گارانتی مقایسه کن و قبل از ثبت سفارش، سازگاری با وسیله‌ات را بررسی کن.',
        brands: [
            { id: 1, name: 'واریان' },
            { id: 25, name: 'واریان پلاس' },
            { id: 26, name: 'اکسون' },
            { id: 41, name: 'صبا باتری' }
        ]
    }
};

export type CompanySlug = keyof typeof companyLandings;
